import { render, staticRenderFns } from "./Template012.vue?vue&type=template&id=286b3f6c&scoped=true&"
import script from "./Template012.vue?vue&type=script&lang=js&"
export * from "./Template012.vue?vue&type=script&lang=js&"
import style0 from "./Template012.vue?vue&type=style&index=0&id=286b3f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b3f6c",
  null
  
)

export default component.exports